import React, { useEffect, useState } from "react";

import { Row, Col, Container } from "react-bootstrap";
import {
  BTCALogo,
  coachDemoImg,
  InfoIconGray,
  LTALogo,
  NATIONALLogo,
} from "../../../constant/imagePath";
import CoachDetailMobile from "./CoachDetailMobile";
import { useHistory } from "react-router-dom";
import classes from "./CoachDetail.module.css";
import { Checkbox } from "../../../stories/Checkbox/Checkbox";
import { Button } from "../../../stories/Button/Button";
import { BookALessonCardWithGallery } from "../../../stories/BookALessonCardWithGallery/BookALessonCardWithGallery";
import { Tabs } from "../../../stories/Tabs/Tabs";
import { CoachDetailsCertificates } from "../../../stories/CoachDetailCertificates/CoachDetailsCertificates";
import { CoachDetailAboutMe } from "../../../stories/CoachDetailAboutMe/CoachDetailAboutMe";
import { CommonQuestions } from "../../../stories/CommonQuestions/CommonQuestions";
import { CoachDetailsTrainingLocations } from "../../../stories/CoachDetailTrainingLocations/CoachDetailsTrainingLocations";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import { WhatOurStudentSay } from "../../../stories/WhatOurStudentSay/WhatOurStudentSay";
import { ReviewBox } from "../../../stories/ReviewBox/ReviewBox";
import { ReviewsWithRating } from "../../../stories/ReviewsOnSidebar/ReviewsOnSidebar";
import { Reviews } from "../../../stories/Reviews/Reviews";
import { Footer } from "../../../stories/Footer/Footer";
import CoachDetailsScheduleCard from "../../../stories/CoachDetailsScheduleCard/CoachDetailsScheduleCard";
import CoachAvailibility from "../../../components/Modals/StudentFlow/CoachDetails/CoachAvailibility/CoachAvailibility";
import Certificate from "../../../components/Modals/StudentFlow/CoachDetails/Certificate/Certificate";

function CoachDetailDesktop() {
  const [selectTab, setSelectTab] = useState({ label: "About me" });
  const [confirmProfile, setConfirmProfile] = useState([]);
  const [checkAvailibility, setCheckAvailibility] = useState(false);
  const [showCertificate, setShowCertificate] = useState(false);

  const [certificateData, setCerificateData] = useState([
    {
      logo: BTCALogo,
      description: "The British Tennis Coaches Association",
      onClick: () => setShowCertificate(true),
    },
    {
      logo: LTALogo,
      description: "LTA Tennis Coaching Qualification",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
    {
      logo: NATIONALLogo,
      description: "National Tennis association",
      onClick: () => console.log(""),
    },
  ]);

  const reviewsData = [
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
        distance: "0.6 m away",
        city: "New York",
        lat: "",
        lng: "",
        aboutMe:
          "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis",
        price: 75,
        rating: 5,
        sport: "Tennis",
        createdAt: "March 10,2022",
      },
      text: "This is my first review",
      createdAt: "March 10,2022",
      rating: 4,
      tags: ["Friendly", "Focused"],
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
        distance: "0.6 m away",
        city: "New York",
        lat: "",
        lng: "",
        aboutMe:
          "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis",
        price: 75,
        rating: 5,
        sport: "Tennis",
        createdAt: "March 10,2022",
      },
      text: "This is my first review",
      createdAt: "March 10,2022",
      rating: 4,
      tags: ["Friendly", "Focused"],
    },
  ];
  const credsAndExpData = [
    {
      heading: "Extensive coaching experience",
      description:
        "John was the former coach of University of San Diego (’78—’96), and has coached over 25,000 students in the past 50 years",
    },
    {
      heading: "Industry recognition",
      description:
        "John is a Four-time San Diego USPTA Coach-of-the-Year, inditeed to the USD Athletic Hall of Fame (2001), and his camp is awarded Tennis Magazine's Top-25 Adult Tennis Camps in 2006",
    },
    {
      heading: "Trusted by Students",
      description:
        "Some of John’s students include Jane Smith (10th in NA) and Sam Wang (8th in NA)",
    },
    {
      heading: "Speicalized in Forehand and backhand",
      description:
        "Consectetur adipiscing elit. Neque pharetra tempor turpis ut quis risus.",
    },
  ];
  const sessionPlanData = {
    description:
      "Every session is based on the athlete's skill level and prior knowledge of the sport. If my student needs to work on improving a specific move or drill for a team or their own personal aspirations, I am always open to working through it.",
    lists: [
      "Footwork",
      "Proper serve",
      "Balance and reflex response",
      "Fore-hand and back-hand drills",
      "Hustle Drills",
      " Playing at the Net",
      "Doubleheader Match - 15 minutes",
    ],
  };
  const history = useHistory();
  return (
    <div className={classes.coachDetails}>
      {/* Header Section */}
      <section
        className={classes.headerSection}
        style={{ background: Colors.neutralShadesOfWhiteSmoke }}
      >
        <AfterLoginHeader
          showSearch
          customStyle={{
            backgroundColor: Colors.neutralShadesOfWhiteSmoke,
            maxWidth: "100%",
            padding: "16px",
            borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
          }}
        />
        <Container fluid className={classes.container}>
          <Row className={classes.firstRow}>
            <Col md={12} xl={12} lg={12}>
              <div className={classes.galleryWithTabs}>
                <BookALessonCardWithGallery
                  onClickbtn3={() => setCheckAvailibility(true)}
                />
              </div>
            </Col>
            <Col md={6} xl={6} lg={6}>
              <h4 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
                More about coach Micahel
              </h4>
              <Tabs
                tabsData={[
                  { label: "About me" },
                  {
                    label: "Credentials and Experience",
                  },
                  { label: "Session plan" },
                ]}
                state={selectTab}
                setState={setSelectTab}
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className={[classes.ScheduleCardSection]}>
        <Row>
          <Col md={6} xxl={7} className={classes.mb80}>
            {selectTab?.label == "About me" && <CoachDetailAboutMe />}
            {selectTab?.label == "Credentials and Experience" && (
              <div
                className={classes.credentialsAndExperience}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
              >
                <ul>
                  {credsAndExpData?.map((item) => {
                    return (
                      <li>
                        <h6
                          style={{
                            ...Fonts.h7,
                            color: Colors.neutralShadesOfNero,
                            lineHeight: "24px",
                          }}
                        >
                          {item?.heading}
                        </h6>
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          {item?.description}
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {selectTab?.label == "Session plan" && (
              <div
                className={classes.sessionPlan}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                }}
              >
                <p
                  style={{
                    ...Fonts.p1,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  {sessionPlanData?.description}
                </p>
                <ul>
                  {sessionPlanData?.lists?.map((item) => {
                    return (
                      <li
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        {item}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </Col>
          <Col md={6} xxl={5} className={[classes.ScheduleCardCol]}>
            <CoachDetailsScheduleCard btnText="Check Full Availability" />
          </Col>
        </Row>
      </section>

      <section className={classes.secondSection}>
        <Container fluid className={`p-0 ${classes.halfContainer}`}>
          <Row className={`g-0 ${[classes.secondRow].join(" ")}`}>
            <Col md={12} className={classes.mb80}>
              <CoachDetailsCertificates data={certificateData} />
            </Col>
            <Col md={12} className={classes.mb80}>
              <CoachDetailsTrainingLocations />
            </Col>
            <Col md={12} className={classes.mb80}>
              <CommonQuestions heading="Common Questions" />
            </Col>
            <Col md={12} className={classes.mb32}>
              <WhatOurStudentSay />
            </Col>
            <Col md={12}>
              <Reviews heading={"What student say"} />
            </Col>
            {reviewsData?.map((item) => {
              return (
                <Col md={12} className={classes.mt32}>
                  <ReviewBox reviewData={item} />
                </Col>
              );
            })}
            <Col md={12} className={classes.mt32}>
              <Button
                size={"Large"}
                primary={false}
                customStyle={{
                  padding: "12px 32px 12px 32px",
                  width: "max-content",
                }}
                label={"Leave a review"}
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Footer */}
      <section className={classes.mt120}>
        <Footer />
      </section>

      <CoachAvailibility
        show={checkAvailibility}
        setShow={setCheckAvailibility}
      />

      <Certificate show={showCertificate} setShow={setShowCertificate} />
    </div>
  );
}

function CoachDetail() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  console.log({ isMobile });
  return isMobile ? <CoachDetailMobile /> : <CoachDetailDesktop />;
}

export default CoachDetail;
